/** Ano corrente e a janela de anos oferecida nos seletores das telas. */
export const CURRENT_YEAR = new Date().getFullYear();

export const YEAR_OPTIONS: number[] = [
  CURRENT_YEAR + 1,
  CURRENT_YEAR,
  CURRENT_YEAR - 1,
  CURRENT_YEAR - 2,
];
